export const companyInfo = {
  name: "Manchi Group",
  tagline: "Innovation. Technology. Excellence.",
  description: "We architect tomorrow's digital infrastructure today. Manchi Group is a premier IT solutions company based in Muscat, Oman, delivering world-class technology services that transform businesses and drive innovation across the Middle East and beyond.",
  email: "info@manchigroup.com",
  phones: ["+968 9823 5616", "+968 9534 3098"],
  address: "#702, Building No: 2112, Way No: 5026, Ghala, Muscat, Oman",
  founded: 2015,
};

export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Contact", href: "#contact" },
];

export const heroData = {
  headline: "Building Digital Futures",
  subheadline: "With Precision & Innovation",
  description: "We deliver enterprise-grade IT solutions that transform businesses. From cloud architecture to cybersecurity, we engineer the technology backbone that powers your success.",
  ctaPrimary: "Start Your Project",
  ctaSecondary: "Explore Services",
};

export const services = [
  {
    id: 1,
    title: "Cyber Security Solutions",
    icon: "ShieldCheck",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&auto=format&q=80",
    description: "Comprehensive cybersecurity solutions that safeguard your digital assets against evolving threats. We design multi-layered defense strategies that protect your organization from data breaches, ransomware, and advanced persistent threats.",
    features: [
      "Threat Detection & Response (MDR/XDR)",
      "Security Operations Center (SOC)",
      "Penetration Testing & Vulnerability Assessment",
      "Security Information & Event Management (SIEM)",
      "Endpoint Detection & Response (EDR)",
      "Identity & Access Management (IAM)",
    ],
    benefits: [
      "Reduce security incidents by up to 90%",
      "24/7 real-time threat monitoring & response",
      "Compliance with ISO 27001, NIST & GDPR",
      "Minimize downtime from cyber attacks",
    ],
    useCases: [
      "Financial institutions requiring PCI-DSS compliance",
      "Government agencies needing zero-trust architecture",
      "Healthcare organizations protecting patient data",
    ],
  },
  {
    id: 2,
    title: "Specialized Application Security",
    icon: "ScanEye",
    image: "https://images.pexels.com/photos/5380596/pexels-photo-5380596.jpeg?auto=compress&cs=tinysrgb&w=800",
    description: "Protect your software applications from the inside out. Our application security experts identify and remediate vulnerabilities across your entire software development lifecycle, ensuring secure code from design to deployment.",
    features: [
      "Static & Dynamic Application Security Testing",
      "Web & Mobile Application Penetration Testing",
      "Secure Code Review & DevSecOps Integration",
      "API Security Assessment",
      "Software Composition Analysis (SCA)",
      "Application Firewall Configuration (WAF)",
    ],
    benefits: [
      "Shift-left security in your SDLC pipeline",
      "Reduce remediation costs by catching bugs early",
      "Protect against OWASP Top 10 vulnerabilities",
      "Achieve secure-by-design application architecture",
    ],
    useCases: [
      "FinTech companies securing payment platforms",
      "E-commerce businesses protecting customer transactions",
      "SaaS providers ensuring multi-tenant security",
    ],
  },
  {
    id: 3,
    title: "Infrastructure Solutions",
    icon: "Server",
    image: "https://images.unsplash.com/photo-1762163516269-3c143e04175c?w=800&auto=format&q=80",
    description: "Build the robust, scalable foundation your business demands. From data center design to network architecture, we engineer infrastructure solutions that deliver maximum performance, reliability, and efficiency.",
    features: [
      "Data Center Design & Optimization",
      "Network Architecture & SD-WAN Deployment",
      "Virtualization & Hyperconverged Infrastructure",
      "Storage Solutions & Data Management",
      "Disaster Recovery & Business Continuity",
      "Physical Security & Environmental Monitoring",
    ],
    benefits: [
      "99.99% uptime guarantee for critical systems",
      "40-60% reduction in infrastructure costs",
      "Seamless scalability for growing businesses",
      "Future-proof architecture with latest technologies",
    ],
    useCases: [
      "Enterprises modernizing legacy data centers",
      "Organizations implementing hybrid cloud strategies",
      "Businesses requiring high-availability infrastructure",
    ],
  },
  {
    id: 4,
    title: "Cloud Solutions",
    icon: "Cloud",
    image: "https://images.unsplash.com/photo-1667984390535-6d03cff0b11a?w=800&auto=format&q=80",
    description: "Accelerate your digital transformation with our end-to-end cloud solutions. Whether migrating existing workloads or building cloud-native applications, we architect solutions across AWS, Azure, and GCP that optimize cost, performance, and agility.",
    features: [
      "Cloud Migration & Modernization Strategy",
      "Multi-Cloud & Hybrid Cloud Architecture",
      "Cloud-Native Application Development",
      "Cloud Security & Governance Frameworks",
      "Cost Optimization & FinOps Implementation",
      "Containerization & Kubernetes Orchestration",
    ],
    benefits: [
      "Reduce TCO by up to 45% with cloud optimization",
      "Achieve infinite scalability on demand",
      "Accelerate time-to-market for new products",
      "Enhance disaster recovery with geo-redundancy",
    ],
    useCases: [
      "Startups building cloud-native SaaS platforms",
      "Enterprises migrating on-premise to cloud",
      "Organizations needing multi-region deployment",
    ],
  },
  {
    id: 5,
    title: "Managed Services & AMC",
    icon: "Headphones",
    image: "https://images.pexels.com/photos/5473955/pexels-photo-5473955.jpeg?auto=compress&cs=tinysrgb&w=800",
    description: "Focus on your core business while we handle your IT operations. Our managed services and Annual Maintenance Contracts provide proactive monitoring, maintenance, and support to keep your systems running at peak performance around the clock.",
    features: [
      "24/7 Infrastructure Monitoring & Alerting",
      "Proactive Patch Management & Updates",
      "Help Desk & Technical Support (L1-L3)",
      "Performance Optimization & Tuning",
      "Annual Maintenance Contracts (AMC)",
      "SLA-Backed Service Level Agreements",
    ],
    benefits: [
      "Reduce IT operational costs by 30-50%",
      "Predictable monthly IT spending (OpEx model)",
      "Minimize unplanned downtime with proactive care",
      "Access to certified expert team without hiring",
    ],
    useCases: [
      "SMBs without dedicated IT departments",
      "Enterprises outsourcing non-core IT functions",
      "Organizations needing 24/7 critical system support",
    ],
  },
  {
    id: 6,
    title: "Consultancy Services",
    icon: "Lightbulb",
    image: "https://images.unsplash.com/photo-1536148935331-408321065b18?w=800&auto=format&q=80",
    description: "Strategic IT consulting that aligns technology with your business objectives. Our seasoned consultants provide expert guidance on digital transformation, technology roadmaps, and IT governance to help you make informed decisions that drive growth.",
    features: [
      "Digital Transformation Strategy & Roadmap",
      "IT Architecture & Technology Advisory",
      "IT Governance & Compliance Consulting",
      "Vendor Selection & Procurement Advisory",
      "Business Process Optimization",
      "Technology Due Diligence & Audits",
    ],
    benefits: [
      "Data-driven decision making for IT investments",
      "Align technology strategy with business goals",
      "Reduce project risks with expert guidance",
      "Accelerate digital transformation initiatives",
    ],
    useCases: [
      "Organizations planning large-scale digital transformation",
      "Companies evaluating new technology investments",
      "Businesses needing regulatory compliance guidance",
    ],
  },
];

export const stats = [
  { value: "150+", label: "Projects Delivered" },
  { value: "98%", label: "Client Retention" },
  { value: "50+", label: "Enterprise Clients" },
  { value: "10+", label: "Years of Excellence" },
];

export const aboutData = {
  title: "Engineering Excellence Since Day One",
  description: "Manchi Group was founded with a singular vision: to bridge the gap between cutting-edge technology and real-world business needs. Based in the heart of Muscat, Oman, we have grown into a trusted technology partner for enterprises across the Middle East.",
  points: [
    "ISO-certified development processes",
    "24/7 dedicated support infrastructure",
    "Agile methodology with transparent delivery",
    "Strategic partnerships with global tech leaders",
  ],
  image: "https://images.unsplash.com/photo-1752170080635-db168448f85d?w=800&auto=format",
};

export const caseStudies = [
  {
    id: 1,
    title: "National Bank Digital Transformation",
    client: "Leading Omani Financial Institution",
    industry: "Banking & Finance",
    duration: "18 Months",
    teamSize: "24 Specialists",
    image: "https://images.unsplash.com/photo-1641931186391-ad626c92cee3?w=800&auto=format&q=80",
    challenge: "The bank operated on a 15-year-old legacy core banking system with frequent outages, manual processes causing transaction delays, and growing cybersecurity vulnerabilities. Customer complaints were rising 30% quarter-over-quarter, and regulatory compliance was at risk.",
    solution: "We executed a phased digital transformation: migrated the core banking platform to a cloud-native microservices architecture on Azure, implemented a zero-trust cybersecurity framework with 24/7 SOC monitoring, deployed AI-powered fraud detection, and built a modern mobile banking application serving 200,000+ users.",
    technologies: ["Azure Cloud", "Kubernetes", "React Native", "Python", "TensorFlow", "SIEM"],
    results: [
      { metric: "99.99%", label: "System Uptime" },
      { metric: "40%", label: "Cost Reduction" },
      { metric: "3x", label: "Transaction Speed" },
      { metric: "Zero", label: "Security Breaches" },
    ],
    testimonial: {
      quote: "Manchi Group didn't just upgrade our technology — they transformed how we serve our customers. The results exceeded every benchmark we set.",
      author: "Chief Technology Officer",
    },
    featured: true,
  },
  {
    id: 2,
    title: "Oil & Gas SCADA Security Overhaul",
    client: "Major Oman Energy Corporation",
    industry: "Oil & Gas",
    duration: "12 Months",
    teamSize: "16 Specialists",
    image: "https://images.unsplash.com/photo-1454779132693-e5cd0a216ed3?w=800&auto=format&q=80",
    challenge: "Critical SCADA (Supervisory Control and Data Acquisition) systems controlling oil production across 40+ field sites were exposed to potential cyber threats. The existing network had no segmentation, outdated firmware, and zero visibility into OT (Operational Technology) network traffic.",
    solution: "Deployed a comprehensive OT security framework including network segmentation between IT and OT environments, implemented industrial-grade firewalls and intrusion detection systems, established a dedicated OT-SOC for real-time monitoring, and conducted red team exercises to validate defenses.",
    technologies: ["Fortinet OT", "Nozomi Networks", "Palo Alto", "Splunk", "CyberArk"],
    results: [
      { metric: "100%", label: "OT Visibility" },
      { metric: "40+", label: "Sites Secured" },
      { metric: "85%", label: "Threat Detection Improvement" },
      { metric: "ISO 62443", label: "Compliance Achieved" },
    ],
    testimonial: {
      quote: "Their understanding of both IT and OT environments was exceptional. We now have complete visibility and control over our critical infrastructure.",
      author: "VP of Operations & Technology",
    },
    featured: false,
  },
  {
    id: 3,
    title: "Smart Government Services Platform",
    client: "Oman Government Ministry",
    industry: "Government & Public Sector",
    duration: "24 Months",
    teamSize: "32 Specialists",
    image: "https://images.unsplash.com/photo-1498084393753-b411b2d26b34?w=800&auto=format&q=80",
    challenge: "Citizens faced long queues and 7-14 day processing times for essential government services. The existing systems were siloed across 12 departments with no data interoperability, resulting in redundant data entry and poor citizen experience.",
    solution: "Built a unified digital services platform integrating all 12 departments through a centralized API gateway. Implemented e-KYC verification, digital document management, automated workflow engines, and a citizen-facing portal with mobile app. Migrated all services to a government private cloud with disaster recovery.",
    technologies: ["AWS GovCloud", "Java Spring Boot", "Angular", "PostgreSQL", "Kafka", "Docker"],
    results: [
      { metric: "92%", label: "Digital Adoption" },
      { metric: "Minutes", label: "Avg. Processing Time" },
      { metric: "12", label: "Departments Unified" },
      { metric: "500K+", label: "Citizens Served" },
    ],
    testimonial: {
      quote: "This platform has fundamentally changed how we deliver public services. What used to take weeks now takes minutes.",
      author: "Director of Digital Transformation",
    },
    featured: false,
  },
  {
    id: 4,
    title: "Hospital Network Cloud Migration",
    client: "Private Healthcare Group",
    industry: "Healthcare",
    duration: "10 Months",
    teamSize: "14 Specialists",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&auto=format&q=80",
    challenge: "A healthcare group operating 5 hospitals and 20+ clinics ran their Electronic Health Records (EHR), imaging systems (PACS), and lab management on aging on-premise servers. Storage was at 94% capacity, backup failures were routine, and scaling required $2M+ in hardware investment.",
    solution: "Designed and executed a HIPAA-compliant hybrid cloud migration strategy. Migrated EHR and PACS to Azure Health Cloud with automated backup and geo-redundant disaster recovery. Implemented identity management, data encryption at rest and in transit, and built a telemedicine platform supporting 10,000+ remote consultations monthly.",
    technologies: ["Azure Health Cloud", "HL7 FHIR", "Terraform", "Active Directory", "Veeam"],
    results: [
      { metric: "60%", label: "Infrastructure Cost Savings" },
      { metric: "99.99%", label: "Data Availability" },
      { metric: "10K+", label: "Monthly Teleconsultations" },
      { metric: "Zero", label: "Data Loss Incidents" },
    ],
    testimonial: {
      quote: "Our clinicians now have instant access to patient records from any location. The reliability improvement alone has been transformative for patient care.",
      author: "Chief Information Officer",
    },
    featured: false,
  },
  {
    id: 5,
    title: "Logistics Network Automation",
    client: "Regional Supply Chain Leader",
    industry: "Logistics & Supply Chain",
    duration: "14 Months",
    teamSize: "18 Specialists",
    image: "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9?w=800&auto=format&q=80",
    challenge: "A logistics company managing 3 warehouses and a fleet of 200+ vehicles relied on manual inventory tracking, paper-based delivery confirmations, and disconnected systems. Inventory accuracy was below 82%, delivery delays averaged 35%, and operational costs were escalating rapidly.",
    solution: "Implemented an end-to-end supply chain digitization: deployed IoT sensors across all warehouses for real-time inventory tracking, built a custom fleet management platform with GPS tracking and route optimization, created an integrated dashboard for operations visibility, and automated order-to-delivery workflows.",
    technologies: ["Node.js", "React", "MongoDB", "IoT Hub", "Power BI", "Redis"],
    results: [
      { metric: "99.2%", label: "Inventory Accuracy" },
      { metric: "45%", label: "Faster Deliveries" },
      { metric: "35%", label: "Cost Reduction" },
      { metric: "Real-time", label: "Fleet Visibility" },
    ],
    testimonial: {
      quote: "We went from spreadsheets and guesswork to real-time visibility across our entire operation. The ROI was realized within the first quarter.",
      author: "Managing Director",
    },
    featured: false,
  },
];

export const partnersData = {
  headline: "Strategic Technology Partners",
  description: "Strategically partnered with leading global technology providers to deliver secure, innovative, and future-ready solutions across cybersecurity, cloud, infrastructure, and digital transformation. Together, we empower businesses to adapt faster, perform smarter, and stay ahead in the digital era.",
  partners: [
    { name: "Dell EMC", category: "Infrastructure", logo: "https://logo.clearbit.com/dell.com" },
    { name: "Citrix", category: "Virtualization", logo: "https://logo.clearbit.com/citrix.com" },
    { name: "Barracuda", category: "Security", logo: "https://logo.clearbit.com/barracuda.com" },
    { name: "AWS", category: "Cloud", logo: "https://logo.clearbit.com/aws.amazon.com" },
    { name: "Zoho", category: "Business Apps", logo: "https://logo.clearbit.com/zoho.com" },
    { name: "HumanFirewall", category: "Security", logo: "https://logo.clearbit.com/humanfirewall.io" },
    { name: "VMware", category: "Virtualization", logo: "https://logo.clearbit.com/vmware.com" },
    { name: "Veeam", category: "Backup & Recovery", logo: "https://logo.clearbit.com/veeam.com" },
    { name: "Vectra AI", category: "Threat Detection", logo: "https://logo.clearbit.com/vectra.ai" },
    { name: "Sophos", category: "Security", logo: "https://logo.clearbit.com/sophos.com" },
    { name: "Microsoft Azure", category: "Cloud", logo: "https://logo.clearbit.com/microsoft.com" },
    { name: "Ivanti", category: "IT Management", logo: "https://logo.clearbit.com/ivanti.com" },
    { name: "F5", category: "Networking", logo: "https://logo.clearbit.com/f5.com" },
    { name: "Fortinet", category: "Security", logo: "https://logo.clearbit.com/fortinet.com" },
    { name: "Google Cloud", category: "Cloud", logo: "https://logo.clearbit.com/cloud.google.com" },
    { name: "Huawei", category: "Infrastructure", logo: "https://logo.clearbit.com/huawei.com" },
  ],
  partnerImages: [
    "https://customer-assets.emergentagent.com/job_premium-it-showcase/artifacts/ajhyc1sq_image.png",
    "https://customer-assets.emergentagent.com/job_premium-it-showcase/artifacts/cjiwe7t8_1.jpg",
    "https://customer-assets.emergentagent.com/job_premium-it-showcase/artifacts/9n75p835_2.jpg",
    "https://customer-assets.emergentagent.com/job_premium-it-showcase/artifacts/w07nmkas_3.jpg",
    "https://customer-assets.emergentagent.com/job_premium-it-showcase/artifacts/7vk5nty9_4.jpg",
  ],
};

export const whyChooseUs = [
  {
    title: "Proven Track Record",
    description: "Over a decade of delivering mission-critical IT solutions for enterprises across diverse industries.",
    icon: "Trophy",
  },
  {
    title: "Certified Experts",
    description: "Our team holds certifications from AWS, Microsoft, Google, and other leading technology providers.",
    icon: "Award",
  },
  {
    title: "24/7 Support",
    description: "Round-the-clock monitoring and support ensures your systems never skip a beat.",
    icon: "Headphones",
  },
  {
    title: "Agile Delivery",
    description: "Transparent, iterative development processes that keep you in control at every stage.",
    icon: "Zap",
  },
];

export const testimonials = [
  {
    name: "Ahmed Al-Rashdi",
    role: "CTO, National Finance Co.",
    quote: "Manchi Group transformed our entire IT infrastructure. Their expertise in cloud migration saved us 40% in operational costs.",
  },
  {
    name: "Sarah Williams",
    role: "VP Engineering, Gulf Logistics",
    quote: "The cybersecurity framework they implemented has been flawless. We haven't had a single breach in three years.",
  },
  {
    name: "Mohammed Al-Balushi",
    role: "CEO, OmanTech Solutions",
    quote: "Their custom software solution automated 80% of our manual processes. A game-changing partnership.",
  },
];


export const faqData = [
  {
    question: "What is your typical engagement process?",
    answer: "Our engagement begins with a free consultation to understand your business challenges and goals. We then conduct a thorough assessment, propose a tailored solution with clear milestones, and upon approval, assemble a dedicated team. Throughout the project, you receive weekly progress reports, access to our project management portal, and direct communication with your project lead.",
  },
  {
    question: "How long do projects typically take to complete?",
    answer: "Project timelines vary based on scope and complexity. A typical cybersecurity assessment takes 4-6 weeks, cloud migration projects range from 3-12 months, and custom software development averages 4-8 months. During our initial consultation, we provide a detailed timeline with phase-wise milestones and clear deliverables at each stage.",
  },
  {
    question: "What industries do you specialize in?",
    answer: "We have deep expertise across Banking & Finance, Oil & Gas, Government & Public Sector, Healthcare, Logistics, Retail, and Education. Our team includes certified specialists with industry-specific knowledge, ensuring solutions that meet sector-specific compliance requirements and operational standards.",
  },
  {
    question: "Do you offer 24/7 support and monitoring?",
    answer: "Yes. Our Managed Services include 24/7/365 infrastructure monitoring, threat detection, and incident response through our Security Operations Center (SOC). We offer multiple SLA tiers — Standard (8x5), Premium (24x7), and Critical (24x7 with 15-minute response time) — to match your business requirements and budget.",
  },
  {
    question: "What sets Manchi Group apart from other IT companies?",
    answer: "Three things differentiate us: First, our strategic partnerships with 16+ global technology leaders like Dell EMC, Fortinet, AWS, and Microsoft Azure give us access to the best tools and preferential support. Second, our team holds 100+ industry certifications. Third, our 98% client retention rate speaks to our commitment to long-term partnerships rather than one-off projects.",
  },
  {
    question: "How do you handle data security and confidentiality?",
    answer: "Security is in our DNA. We follow ISO 27001 certified processes, sign comprehensive NDAs before any engagement, use encrypted communication channels, implement role-based access controls for all project data, and conduct regular internal security audits. Our team undergoes annual security awareness training and background verification.",
  },
  {
    question: "What is your pricing model?",
    answer: "We offer flexible pricing models: Fixed-price for well-defined projects, Time & Materials for evolving requirements, and Managed Services with predictable monthly billing. Annual Maintenance Contracts (AMC) are available for ongoing support. We provide transparent, detailed proposals with no hidden costs — and our initial consultation is always free.",
  },
];
